<ion-grid class="ion-no-padding height-100">
  <ion-row class="ion-justify-content-center  main-wrapper">
    <ion-col >
      <div class="heading-wrapper">
        <div class = "tag-line"><span class = "bold">Your skills</span></div>
      </div>

      <div class="form-wrapper">
        <div class="card-wrapper" *ngFor="let item of skills; let i = index;">
          <div class="skill-label">
            {{ item.name }}
          </div>
      </div>
      </div>
    </ion-col>
  </ion-row>
</ion-grid>
